module.exports = __webpack_public_path__ + "img/card_moment@3x.8bf9597e.png";